// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../node_modules/rescript/lib/es6/list.js";
import * as $$Array from "../../../../../node_modules/rescript/lib/es6/array.js";
import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as ContentTypes from "../../../../common/types/ContentTypes.bs.js";
import * as ContentHelper from "../../../../common/helper/ContentHelper.bs.js";
import * as ImageContentCmp from "./img-container/ImageContentCmp.bs.js";
import * as TrackLiveTripConfig from "../../domain/store/TrackLiveTripConfig.bs.js";
import * as TrackLiveTripMarketingTitleCmp from "./TrackLiveTripMarketingTitleCmp.bs.js";
import * as TrackLiveTripMarketingVMMapper from "../view-model/TrackLiveTripMarketingVMMapper.bs.js";

function getUsecaseDesc(input) {
  return Belt_Option.mapWithDefault(input, "", (function (x) {
                return Belt_Option.getWithDefault(x.desc, "");
              }));
}

function isActiveUsecase(current_goods, ref_goods) {
  return Belt_Option.mapWithDefault(current_goods, ContentTypes.createTitle(""), (function (x) {
                return x.text;
              })) === ref_goods.text;
}

function getVehicleIcon(use_case, available_vehicles) {
  var goods_mapped_vehicles = use_case !== undefined ? List.filter(function (item) {
            var vehicle_goods = item.use_cases;
            if (vehicle_goods !== undefined) {
              return ContentHelper.getContent(vehicle_goods) === use_case;
            } else {
              return false;
            }
          })(available_vehicles) : /* [] */0;
  if (List.length(goods_mapped_vehicles) > 0) {
    return ContentTypes.urltoString(List.hd(goods_mapped_vehicles).icon.path);
  } else {
    return "";
  }
}

function TrackLiveTripMarketingGoodsCmp(Props) {
  var available_vehicles = Props.available_vehicles;
  var goods_list = Props.goods_list;
  var selected_goods = Props.selected_goods;
  var services_handler = Props.services_handler;
  return React.createElement("div", {
              className: "track-live-trip-marketing__categories-container"
            }, React.createElement(TrackLiveTripMarketingTitleCmp.make, {
                  title: TrackLiveTripConfig.marketing_goods_title
                }), React.createElement("div", {
                  className: "categories"
                }, React.createElement("div", {
                      className: "category-list"
                    }, goods_list !== undefined ? $$Array.of_list(List.mapi((function (key, service) {
                                  return React.createElement("div", {
                                              key: String(key),
                                              className: "individual-category",
                                              onClick: (function (param) {
                                                  Curry._1(services_handler, service);
                                                  return TrackLiveTripMarketingVMMapper.publishGAEvents("Nature of Goods " + ContentTypes.titleToString(service.text), "");
                                                })
                                            }, React.createElement(ImageContentCmp.make, {
                                                  title: ContentTypes.titleToString(service.text),
                                                  class_name: "img " + Belt_Option.getWithDefault(service.class_name, ""),
                                                  background_img: ContentTypes.assetPathToString(service.src_path),
                                                  container_class_name: "service-item"
                                                }), isActiveUsecase(selected_goods, service) ? React.createElement("div", {
                                                    className: "service-selector"
                                                  }) : null);
                                }), goods_list)) : null), React.createElement("div", {
                      className: "category-desc"
                    }, React.createElement(ImageContentCmp.make, {
                          title: "",
                          class_name: "img",
                          background_img: getVehicleIcon(selected_goods, available_vehicles),
                          container_class_name: "vehicle-img"
                        }), React.createElement("div", {
                          className: "desc"
                        }, getUsecaseDesc(selected_goods)))));
}

var make = TrackLiveTripMarketingGoodsCmp;

export {
  getUsecaseDesc ,
  isActiveUsecase ,
  getVehicleIcon ,
  make ,
  
}
/* react Not a pure module */
